import { gql } from "@apollo/client"

const UPDATE_ATTENDANCE_MUTATION = gql`
  mutation($input: UpdateAttendanceInput!) {
    updateAttendance(input: $input)
  }
`

export { UPDATE_ATTENDANCE_MUTATION }
